import React from "react"

import { Control } from "react-hook-form"

import RatingSelect from "./RatingSelect"
import SectionHeader from "./SectionHeader"

interface CustomerInteractionSectionProps {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  control: Control<any>
  calculateResult: () => void
}

const customerInteractionOptions = [
  { value: "Up to Standard", label: "Up to Standard" },
  { value: "Satisfactory", label: "Satisfactory" },
  { value: "Needs Improvement", label: "Needs Improvement" },
  { value: "Failed Protocol", label: "Failed Protocol" },
]

const CustomerInteractionSection: React.FC<CustomerInteractionSectionProps> = ({
  control,
  calculateResult,
}) => {
  return (
    <div className="space-y-4">
      <SectionHeader title="Customer Interaction & Problem Solving" />

      <div className="grid grid-cols-2 gap-4">
        <RatingSelect
          control={control}
          name="customerInteractionScores.customerFeedback"
          label="Customer Feedback"
          options={customerInteractionOptions}
          calculateResult={calculateResult}
        />
        <RatingSelect
          control={control}
          name="customerInteractionScores.issueResolution"
          label="Issue Resolution"
          options={customerInteractionOptions}
          calculateResult={calculateResult}
        />
      </div>
    </div>
  )
}

export default CustomerInteractionSection
